// extracted by css-extract-rspack-plugin
export default {"back-top":"back-top-FfsWKO","backTop":"back-top-FfsWKO"};